module.exports = __webpack_public_path__ + "static/IddeaImg-fca99ad5648121f404a5cbb990ad0d24.jpg";